<template>
  <div class="receive-accessory-delivery">
    <el-button type="primary" @click="dialogVisible = true">确认签收辅料</el-button>

    <el-dialog title="确认签收辅料" :visible.sync="dialogVisible" append-to-body>
      <el-table size="small" :data="unReceivedAccessories" border @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="name" label="辅料名称"></el-table-column>
        <el-table-column prop="image" label="图片">
          <template slot-scope="scope">
            <el-image style="width: 60px; height: 60px;" :src="scope.row.image.url" :preview-src-list="[scope.row.image.url]" />
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :disabled="selectedAccessories.length === 0" @click="handleSubmit">确认签收</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ReceiveAccessoryDelivery extends Vue {
  @Prop({ type: Array, default: () => [] }) accessories;
  @Prop({ type: Number }) orderAccessoryDeliveryId;

  dialogVisible = false;
  selectedAccessories = [];

  get unReceivedAccessories() {
    return this.accessories.filter(item => !item.received);
  }

  handleSelectionChange(selection) {
    this.selectedAccessories = selection;
  }

  async handleSubmit() {
    await this.$autoLoading(this.$request.put(`/order_accessory_deliveries/${this.orderAccessoryDeliveryId}/receive`, {
      accessory_ids: this.selectedAccessories.map(item => item.id)
    }));
    this.$message.success(this.$t('operateSuccess'));
    this.dialogVisible = false;
    this.$emit('success');
  }
}
</script>
